module.exports = __webpack_public_path__ + "static/real-time-data-updates-f9df2800bb132a9e6952c2b145be0704.png";